export default __webpack_public_path__ + "static/media/eggInfographic.15bc36de.png";